import moment from 'moment';
import classNames from 'classnames';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Checkbox, Popover, Row } from 'components-antd';
import { Skeleton } from 'antd';
import { ArrowDown, ArrowUp } from 'components/Icons';
import { Card } from '../../Card';
import {
  getLoadingGraphsSelector,
  getFilteredGraphsSelector,
} from 'store/selectors/agentDashboard';
import { AreaConfigData, clientStats } from '../helper';

import { appManageClientDrawerAction, appSetClientDrawerActiveTab } from 'store/actions/app';

import styles from '../styles.module.scss';

export const ClientWidget = ({ teamStats }) => {
  const filterValues = ['Active', 'Retention'];
  const [filter, setFilter] = useState<string>('Active');
  const [open, setOpen] = useState(false);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [data, setData] = useState<AreaConfigData[]>([] as AreaConfigData[]);
  const [currentStats, setCurrentStats] = useState<clientStats>();

  const { isPending } = useSelector(getLoadingGraphsSelector);
  const stats = useSelector(getFilteredGraphsSelector('client', teamStats));
  const dispatch = useDispatch();

  useEffect(() => {
    !isPending && setCurrentStats(stats);
  }, [isPending, teamStats]);

  useEffect(() => {
    if (currentStats) {
      setTotalAmount(currentStats?.[filter] || 0);
    }
  }, [currentStats]);

  const handleChange = (checkedValues) => {
    setOpen(false);
    const currentValue = checkedValues.target.value;
    setFilter(currentValue);
    setTotalAmount(currentStats?.[currentValue] || 0);
  };
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const openClientTab = () => {
    if (filter === 'Active') {
      dispatch(appSetClientDrawerActiveTab(0));
    } else {
      dispatch(appSetClientDrawerActiveTab(1));
    }
    dispatch(appManageClientDrawerAction(true));
  };
  const popoverContent = () => (
    <ul className={styles.filterOptions}>
      {filterValues.map((value, index) => {
        return (
          <li key={index}>
            <Checkbox
              className={styles.sortCheckbox}
              onChange={handleChange}
              checked={value == filter}
              value={value}
            >
              <div className={styles.checkboxHeading}>{value}</div>
            </Checkbox>
          </li>
        );
      })}
    </ul>
  );

  return (
    <Card
      cardTitle={'Clients'}
      showHeader={false}
      cardWrapperClassName={classNames(styles.cardWrapper, styles.clients)}
      cardHeaderClassName={styles.cardHeader}
      cardBodyClassName={styles.cardBody}
    >
      <Fragment>
        <header className={styles.widgetHeader}>
          <div>
            <h3
              className={classNames({ [styles.headerText]: totalAmount !== 0 })}
              onClick={openClientTab}
            >
              {'Clients'}
            </h3>
          </div>

          {!isPending && (
            <Popover
              content={popoverContent}
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
              overlayClassName={styles.filterDropdown}
              placement="bottomRight"
              className={styles.dropdown}
            >
              <span className={styles.switchButton} onClick={(e) => e.preventDefault()}>
                {filter}
              </span>

              {open ? (
                <ArrowUp className={styles.icon} />
              ) : (
                <ArrowDown className={styles.icon} color={'#747475'} />
              )}
            </Popover>
          )}
        </header>

        {isPending ? (
          <Skeleton.Input active size="large" className={styles.loaderSkeleton} />
        ) : (
          <Row
            className={classNames(styles.countContainer, {
              [styles.clickable]: totalAmount !== 0,
            })}
          >
            <span className={styles.totalAmount} onClick={openClientTab}>
              {totalAmount}
            </span>
          </Row>
        )}
      </Fragment>
    </Card>
  );
};
